import {Main} from '../../components/main/main.tsx';
import {Page} from '../../components/page/page.tsx';
import {PageTitle} from '../../components/page/page_title.tsx';
import {__} from '../../support/lang/translations.ts';
import {Card} from '../../components/card/card.tsx';
import {FlexRow} from '../../components/utility/flex_row.tsx';
import {CardList} from '../../components/card/card_list.tsx';
import {Icon} from '../../components/icon/icon.tsx';
import {PageContent} from '../../components/page/page_content.tsx';
import {useAppSelector} from '../../store/store.ts';

export function Damage() {
    const meData = useAppSelector((state) => state.customerInfo.me?.customer);
    const defaultLocationId = meData?.default_location_id;
    const locations = useAppSelector((state) => state.appConfig.locations);
    const organisation = useAppSelector((state) => state.appConfig.organisation);
    const location = locations
        ? defaultLocationId
            ? locations?.filter((l) => l?.id === defaultLocationId)[0]
            : null
        : null;
    const emailAddress = location ? location.email : organisation?.email;
    const baseUrl = 'https://www.mobielschademelden.nl';
    const url = emailAddress ? `${baseUrl}/?tussenpersoonemail=${emailAddress}` : baseUrl;

    return (
        <Main>
            <Page>
                <PageTitle>
                    <h1>{__('damage.titles.index')}</h1>
                </PageTitle>

                <PageContent>
                    <p className="text-center">{__('damage.copy.index')}</p>
                </PageContent>
                <PageContent>
                    <CardList>
                        <Card target="_blank" to={url} arrow={true}>
                            <FlexRow>
                                <Icon iconClassName="fa-light fa-link" outline={false} />
                                <strong style={{margin: '0 auto 0 1rem'}}>{__('damage.links.open_damage_form')}</strong>
                            </FlexRow>
                        </Card>

                        {meData != null && (
                            <Card to="/chat" arrow={true}>
                                <FlexRow>
                                    <Icon iconClassName="fa-regular fa-comment" outline={false} />
                                    <strong style={{margin: '0 auto 0 1rem'}}>{__('damage.links.start_chat')}</strong>
                                </FlexRow>
                            </Card>
                        )}
                    </CardList>
                </PageContent>
            </Page>
        </Main>
    );
}
